
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import StrategyNotFound from "@/components/follow-strategy/StrategyNotFound";
import FreeStrategyDetails from "@/components/follow-strategy-free/FreeStrategyDetails";
import FreeStrategyActions from "@/components/follow-strategy-free/FreeStrategyActions";
import { useIsMobile } from "@/hooks/use-mobile";
import ChatOption from "@/components/ChatOption";

const FollowStrategyFree = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const strategy = location.state?.strategy;
  const filters = location.state?.filters;

  const isMobile = useIsMobile();

  const defaultStrategyData = {
    name: "BlueScaleSolution",
    performance: "15.90%",
    riskLevel: "High",
    minInvestment: "2,001 USDT",
    since: "90 days",
    exchange: "BYBIT",
    followers: 81,
    winRate: 97,
    maxDrawdown: 15.4,
    tradesWon: 304,
    tradesLost: 0,
    aum: 187834.75,
    description: "Trading strategy for BlueScaleSolution"
  };

  if (!strategy) {
    return <StrategyNotFound filters={filters} />;
  }

  // Apply defaults only for missing fields and ensure isPremium is false for free strategies
  const strategyData = {
    ...defaultStrategyData,
    ...strategy,
    isPremium: false
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F5F7FB] to-white">
      <Header />
      <main className="container mx-auto px-4 py-8 max-w-4xl">
        <button
          onClick={() => navigate('/marketplace', { state: { filters } })}
          className="flex items-center text-gray-600 hover:text-gray-800 mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </button>

        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="bg-green-100 rounded-lg p-6 mb-8">
            <h2 className="text-xl font-semibold text-green-800 mb-2">Free Trading Strategy</h2>
            <p className="text-green-700">
              You're about to follow a free trading strategy—no payment required. Simply follow the next steps to get started instantly.
            </p>
          </div>

          <h1 className="text-3xl font-bold text-[#1B2F47] mb-8">
            Follow {strategyData.name}
          </h1>

          <div className="grid md:grid-cols-2 gap-12">
            <FreeStrategyDetails strategy={strategyData} />
            <FreeStrategyActions
              strategy={strategyData}
              isSubmitting={isSubmitting}
              setIsSubmitting={setIsSubmitting}
              navigate={navigate}
              originalStrategyId={location.state?.originalStrategyId}
            />
          </div>
        </div>
      </main>
      {/* Only show ChatOption on desktop */}
      {!isMobile && (
        <ChatOption />
      )}
      <Footer />
    </div>
  );
};

export default FollowStrategyFree;
